export const UPGRADED_BASIC_NEMESIS_CARDS_DB_KEY =
  'upgradedBasicNemesisCards-1.8'
